import React from 'react';
import { fetchClusterSpinUpsByCategoryAggregate } from 'service/service';
import ClusterByCategoryBase from './ClusterByCategoryBase';

const ClusterSpinsUpByCategory: React.FC = () => {
    return (
        <ClusterByCategoryBase
            breadcrumbName="Clusters Spin-Ups by Category"
            tableTitlePrefix="New Clusters"
            serviceFunc={(p) => fetchClusterSpinUpsByCategoryAggregate({
                startDate: p.startDate,
                endDate: p.endDate,
                sector: p.sector,
                env: p.env,
                location: p.location,
                page: p.page,
                pageSize: p.pageSize,
                selectedDateInString: p.selectedDateInString,
                computeType: p.clusterCategory
            })}
            navigationPath="/databricksADB/clusterSpinsupByCategory_details"
            preserveFilterKey="cluster_spinsUp_filters"
            tableType="cluster-spinsUp-by-category"
        />
    );
};

export default ClusterSpinsUpByCategory;

